"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsCalloutManagement = exports.googleAdsCalloutManagementArgsSchema = exports.GoogleAdsCalloutAction = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// ---------- Add Callout ----------
var googleAdsAddCalloutInputSchema = zod_1.z
    .object({
    campaignId: zod_1.z
        .string()
        .nullish()
        .describe('The campaign ID to attach the callout to (required if assetGroupId and adGroupId are not provided).'),
    assetGroupId: zod_1.z
        .string()
        .nullish()
        .describe('Optional asset group ID to attach the callout to (for Performance Max campaigns).'),
    adGroupId: zod_1.z
        .string()
        .nullish()
        .describe('Optional ad group ID to attach the callout to (for Search/Display campaigns).'),
    calloutText: zod_1.z
        .string()
        .min(1)
        .max(25, 'Callout text must be 25 characters or less')
        .describe('The callout text that will be displayed. CRITICAL: Maximum 25 characters (including spaces). Count characters BEFORE calling. Examples: "24/7 Customer Support" (21 chars), "Free Shipping" (13 chars), "Price Match Guarantee" (21 chars).'),
})
    .describe('Add a callout extension to a Google Ads campaign, asset group, or ad group.');
var googleAdsAddCalloutArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsAddCalloutInputSchema);
var googleAdsAddCalloutResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    calloutId: zod_1.z.string().describe('The ID of the created callout asset'),
    linkTarget: zod_1.z
        .enum(['campaign', 'assetGroup', 'adGroup'])
        .describe('The type of entity the callout is linked to'),
    message: zod_1.z.string().nullish().describe('Additional information about the callout creation'),
});
var googleAdsAddCalloutResultSchema = googleAdsAddCalloutResponseSchema;
// ==========================
// Compound Tool: googleAdsCalloutManagement
// ==========================
exports.GoogleAdsCalloutAction = zod_1.z.enum(['addCallout']);
exports.googleAdsCalloutManagementArgsSchema = zod_1.z.object({
    action: zod_1.z.discriminatedUnion('name', [
        zod_1.z.object({
            name: zod_1.z.literal('addCallout'),
            params: googleAdsAddCalloutArgsSchema.shape.args,
        }),
    ]),
    emitMode: zod_1.z.literal('single'),
});
var GoogleAdsCalloutManagementAllResultsSchema = googleAdsAddCalloutResultSchema;
var googleAdsCalloutManagementResultSchemas = (0, common_1.defineDynamicSchemas)()({
    dependencies: ['action.name'],
    variants: [{ when: { 'action.name': 'addCallout' }, schema: googleAdsAddCalloutResultSchema }],
    defaultSchema: GoogleAdsCalloutManagementAllResultsSchema,
});
exports.googleAdsCalloutManagement = (0, common_1.createToolMetadata)({
    id: 'googleAdsCalloutManagement',
    displayName: 'Google Ads Callout Management',
    displayDescription: 'Add callout extensions to Google Ads campaigns',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsCalloutManagementArgsSchema,
}, googleAdsCalloutManagementResultSchemas);
